<div class="detail-container">
  <nb-card [nbSpinner]="loading() || saving()">
    <nb-card-header>
      <h5>Aktionen</h5>
      @if (canEdit() && !isEditing()) {
        <button nbButton ghost status="primary" (click)="onEdit()">
          <nb-icon pack="eva" icon="edit-outline"></nb-icon>
          Bearbeiten
        </button>
      }
    </nb-card-header>
    <nb-card-body>
      <wr-banner status="info"
                 [icon]="{ icon: 'info-outline', pack: 'eva' }"
                 message="Die Kategorie bestimmt Farbe, Statistik-Gewichtung und Verhalten (z. B. Frist bei Gefahr). Die Reihenfolge bestimmt die Sortierung in der Auswahl.">
      </wr-banner>
      <div class="action-list">
        @for (form of actionForms(); track form; let index = $index) {
          <div class="action-item" [formGroup]="form">
            <input nbInput fullWidth formControlName="name" placeholder="Name der Aktion">
            <nb-select formControlName="severity" class="severity-select">
              @for (option of severityOptions; track option.value) {
                <nb-option [value]="option.value">
                  <span class="severity-dot" [class]="'severity-dot ' + option.status"></span>
                  {{ option.label }}
                </nb-option>
              }
            </nb-select>
            <span class="severity-dot" [class]="'severity-dot ' + severityStatus(form)"></span>
            <div class="action-buttons">
              <button nbButton outline size="small" type="button"
                      [disabled]="!isEditing() || index === 0"
                      (click)="moveAction(index, -1)">
                <nb-icon pack="eva" icon="arrow-upward-outline"></nb-icon>
              </button>
              <button nbButton outline size="small" type="button"
                      [disabled]="!isEditing() || index === actionForms().length - 1"
                      (click)="moveAction(index, 1)">
                <nb-icon pack="eva" icon="arrow-downward-outline"></nb-icon>
              </button>
              <button nbButton outline size="small" status="danger" type="button"
                      [disabled]="!isEditing()"
                      (click)="removeAction(index)">
                <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
              </button>
            </div>
          </div>
        }
      </div>
      <button nbButton outline status="primary" type="button" [disabled]="!isEditing()" (click)="addAction()">
        <nb-icon pack="eva" icon="plus-outline"></nb-icon>
        Aktion hinzufügen
      </button>
    </nb-card-body>
    @if (canEdit()) {
      <nb-card-footer>
        <button size="medium" [disabled]="!isEditing()" nbButton status="primary" (click)="submit()">Speichern</button>
        <button size="medium" [disabled]="!isEditing()" nbButton status="basic" (click)="cancel()">Abbrechen</button>
      </nb-card-footer>
    }
  </nb-card>
</div>
